/** Health suggestions are derived from the user's own records. */
export function isPersonalizedQuerySource(querySource) {
    return querySource === 'health';
}
//# sourceMappingURL=personalizedQuerySource.js.map